import { render } from "./BlogRightSidebarPage.vue?vue&type=template&id=fb649358"
import script from "./BlogRightSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lindelwankosinathi/Documents/projects/renaissancecs/node_modules/.pnpm/vue-loader@16.8.3_vue@3.2.39+webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__